<template>
    <div>
        <v-btn icon @click="goToEditPage()" flat class="mx-0">
            <v-icon class="my-auto" color="primary" small>fas fa-edit</v-icon>
        </v-btn>
    </div>
</template>

<script>
    import Vue from 'vue';
    import router from '../../router'

    export default Vue.extend({
        name: 'ListOptionsComponent',
        data() {
            return {}
        },
        methods: {
            goToEditPage () {
              router.push('/' + this.params.modulo + '/' + this.params.data.id)
            },
        }
    });
</script>

<style >
</style>



// WEBPACK FOOTER //
// src/components/shared/ListOptionsComponent.vue